import React from "react";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";
import DialogBox from "../util/DialogBox";
import SavedCards from "./SavedCards";
import { useTranslation } from "react-i18next";

function CreditCards() {
  const { t } = useTranslation();
  const savedCards = [];

  const showCardOperationsUnavailable = () => {
    DialogBox({
      text: t("addCardError"),
      icon: "error",
      confirmButtonText: "OK",
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("jest: handleSubmit appelé");
    showCardOperationsUnavailable();
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-6 mt-4">
          <div className="card mb-4 shadow">
            <form onSubmit={handleSubmit} className="formCard">
              <div className="card-header fw-bolder bg-light">
                {t("cardInformations")}
              </div>
              <div className="card-body">
                <label
                  htmlFor="cardNumber"
                  className="fw-bolder"
                  aria-label="Numéro de carte"
                >
                  {t("cardNumber")}
                </label>
                <CardNumberElement className="form-control" id="cardNumber" />
                <br />
                <div className="row">
                  <div className="col">
                    <label
                      htmlFor="cardExpiry"
                      className="fw-bolder"
                      aria-label="Date d'expiration"
                    >
                      {t("expirationDate")}
                    </label>
                    <CardExpiryElement
                      className="form-control"
                      id="cardExpiry"
                    />
                  </div>
                  <div className="col">
                    <label
                      htmlFor="cardCvc"
                      className="fw-bolder"
                      aria-label="Code de vérification (CVV)"
                    >
                      {t("verificationCode")}
                    </label>
                    <CardCvcElement className="form-control" id="cardCvc" />
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-center">
                <button type="submit" className="btn btn-success ">
                  {t("addCard")}
                </button>
              </div>
              <br />
            </form>
          </div>
        </div>
        <div className="col-md-6">
          <SavedCards
            savedCards={savedCards}
            handleRemoveSavedCard={showCardOperationsUnavailable}
            hidePaymentBouton={true}
            hidePaymentFormBouton={true}
          />
          {savedCards.length > 0 && (
            <div className="d-flex justify-content-center mt-3">
              <button
                className="btn btn-danger"
                onClick={showCardOperationsUnavailable}
              >
                {t("deleteCardsBtn")}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CreditCards;
